/* Pépites — motion, after the mockup (docs/design-pepites-ok.html: pagein, .rev/.vu, animated jauges).
   - blocks below the fold rise in as they scroll into view (what is already on screen is left alone,
     the page fade-up in pepites.css covers it);
   - lot gauges fill from 0 and their counter counts up when they come into view;
   - the home palette band slides a little once per visit, to show that it scrolls.
   layout/theme.liquid sets .pp-motion on <html> only when the visitor allows motion; without it nothing runs. */
(() => {
  const html = document.documentElement;
  window.ppMotion = true;
  if (!html.classList.contains('pp-motion')) return;

  // ---------------------------------------------------------------- reveal on scroll
  const REVEAL = [
    '.pp-sec-head', '.pp-sect .pp-carte-p', '.pp-frise > div', '.pp-carte-lot', '.pp-wrap > .pp-carte-p',
    '.product-grid__item', '.wine-tasting', '.wine-details', '.producer-card', '.group-buying',
  ].join(',');
  const io = new IntersectionObserver((entries) => {
    let k = 0;
    entries
      .filter((x) => x.isIntersecting)
      .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left)
      .forEach((x) => {
        const el = x.target;
        io.unobserve(el);
        el.style.transitionDelay = `${(k++ % 5) * 55}ms`;
        el.classList.add('pp-vu');
        const done = (ev) => {
          if (ev.target !== el) return;
          el.removeEventListener('transitionend', done);
          el.classList.remove('pp-rev', 'pp-vu');
          el.style.transitionDelay = '';
        };
        el.addEventListener('transitionend', done);
      });
  }, { rootMargin: '0px 0px -8% 0px' });
  const fold = innerHeight * 0.92;
  document.querySelectorAll(REVEAL).forEach((el) => {
    if (el.closest('.pp-rev') || el.getBoundingClientRect().top < fold) return;
    el.classList.add('pp-rev');
    io.observe(el);
  });

  // ---------------------------------------------------------------- gauges
  const count = (b, n) => {
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min(1, (t - t0) / 900);
      b.textContent = String(Math.round(n * (1 - Math.pow(1 - p, 3))));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const jio = new IntersectionObserver((entries) => entries.forEach((x) => {
    if (!x.isIntersecting) return;
    jio.unobserve(x.target);
    const j = x.target;
    setTimeout(() => j.classList.add('pp-rempli'), 120);
    const b = j.nextElementSibling && j.nextElementSibling.querySelector('b');
    const n = b ? parseInt(b.textContent, 10) : 0;
    if (n > 0) { b.textContent = '0'; setTimeout(() => count(b, n), 120); }
  }), { threshold: 0.6 });
  document.querySelectorAll('.pp-jauge').forEach((j) => jio.observe(j));

  // ---------------------------------------------------------------- palette band hint
  const band = document.getElementById('pp-hero-lots');
  let seen = false;
  try { seen = sessionStorage.getItem('pp-nudge') === '1'; } catch (e) {}
  if (band && !seen && band.children.length > 1 && band.scrollWidth > band.clientWidth + 8) {
    const nio = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      nio.disconnect();
      try { sessionStorage.setItem('pp-nudge', '1'); } catch (e) {}
      band.classList.add('pp-nudge');
      band.addEventListener('animationend', () => band.classList.remove('pp-nudge'), { once: true });
    }, { threshold: 0.7 });
    nio.observe(band);
  }
})();
